/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAdvisorBookingDetailModel } from '../../models/medical-advisor-booking-detail-model';

export interface MedicalAdvisorBookingDetailUrnBookingIdGet$Params {
  urnBookingId: string;
}

export function medicalAdvisorBookingDetailUrnBookingIdGet(http: HttpClient, rootUrl: string, params: MedicalAdvisorBookingDetailUrnBookingIdGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<MedicalAdvisorBookingDetailModel>> {
  const rb = new RequestBuilder(rootUrl, medicalAdvisorBookingDetailUrnBookingIdGet.PATH, 'get');
  if (params) {
    rb.path('urnBookingId', params.urnBookingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<MedicalAdvisorBookingDetailModel>;
    })
  );
}

medicalAdvisorBookingDetailUrnBookingIdGet.PATH = '/MedicalAdvisor/BookingDetail/{urnBookingId}';
